import React from 'react';
import { connect } from 'react-redux';
import { SiteContainer } from 'core/layout';
import {
  CardsSection,
  NewsSection,
} from 'modules';
import { Banner } from './components';
import transformData from './transformData';

class Kategorija extends React.PureComponent {
  render() {
    const data = transformData(this.props.data, this.props.lang);
    const layout = this.props.breakpoint;

    const renderSection = (key) => {
      const section = data.sections[key];
      const sectionProps = {
        key,
        id: key,
        data: section,
        layout,
      };

      switch (key) {
        case 'jaunumi':
          return section.items && section.items.length > 0 ? <NewsSection {...sectionProps} /> : null;
        default:
          return section.items && section.items.length > 0 ? <CardsSection {...sectionProps} /> : null;
      }
    }

    return (
      <div>
        {data.banner && (
          <Banner
            data={data.banner}
          />
        )}

        <main>
          <SiteContainer>
            {Object.keys(data.sections).map(key => renderSection(key))}
          </SiteContainer>
        </main>
      </div>
    );
  }
}

const mapStateToProps = ({breakpoint}) => ({
  breakpoint
});

export default connect(mapStateToProps)(Kategorija)



// WEBPACK FOOTER //
// ./src/pages/Kategorija/Kategorija.jsx